<template>
    <div class="main-content">
        <b-card>HELP</b-card>
    </div>
</template>

<script>
export default {
    name: 'Help',
}
</script>
